import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "close.icon",
  "use": "close.icon-usage",
  "viewBox": "-14473.224 -11934.224 20.447 20.447",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-14473.224 -11934.224 20.447 20.447\" id=\"close.icon\"><path d=\"M25.447,7.059,23.388,5l-8.164,8.164L7.059,5,5,7.059l8.164,8.164L5,23.388l2.059,2.059,8.164-8.164,8.164,8.164,2.059-2.059-8.164-8.164Z\" transform=\"translate(-14478.224 -11939.224)\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/close.icon.svg
// module id = UuQD
// module chunks = 13